/* eslint-disable */
export default {
  infoMessageMins: '{delayTime}분 후 로그인 자동 저장...',
  infoMessageMin: '{delayTime}분 후 로그인 자동 저장...',
  infoMessageSecs: '{delayTime}초 후 로그인 자동 저장...',
  infoMessageSec: '{delayTime}초 후 로그인 자동 저장...',
} as const;

// @key: @#@"infoMessageMins"@#@ @source: @#@"Auto-save log in {delayTime} minutes..."@#@
// @key: @#@"infoMessageMin"@#@ @source: @#@"Auto-save log in {delayTime} minute..."@#@
// @key: @#@"infoMessageSecs"@#@ @source: @#@"Auto-save log in {delayTime} seconds..."@#@
// @key: @#@"infoMessageSec"@#@ @source: @#@"Auto-save log in {delayTime} second..."@#@
